import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: '画面別コンテンツ',
  
  // model
  screenModel: [],

  // form
  values: {}
}

const getters = {
  get: state => state,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        // case 'screenOrientationKbn':
          // return Utility.getConstantsLabel(['Mst', 'ScreenOrientation'], value)
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {screenSettingParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceContentsSetting'],
        ['v1ServiceContentsScreenListGet'],
        [screenSettingParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setValues', res[0].data.serviceContentsBasicInfo)
            commit('setScreenModel', res[0].data.serviceContentsScreenSettings)
            console.log('values', state.values)
            console.log('screenModel', state.screenModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  }
}

const mutations = {
  // model
  setScreenModel (state, data) {
    Vue.set(state, 'screenModel', data)
  },

  // form
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
